import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConfirmModal = ({
  show,
  onHide,
  title = "Confirm Action",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "danger",
  onConfirm,
  isLoading = false,
  centered = true,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => !isLoading && onHide()}
      centered={centered}
    >
      <Modal.Header closeButton={!isLoading}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {typeof message === "string" ? <p>{message}</p> : message}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={isLoading}
        >
          {cancelText}
        </Button>

        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? <Spinner size="sm" /> : confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
